import { Box, Divider, FormLabel } from '@mui/material';
import { MDBox } from '../MDBox';
import { MDTypography } from '../MDTypography';

interface IProps {
    heading: string;
    createdDateUTC: string;
    createdByName: string;
    lastModifiedDateUTC?: string | null;
    lastModifiedByName?: string | null;
}

const labelSx = { fontSize: '0.875rem', display: 'block', mb: 0.5 };

const formatDate = (value: string) =>
    new Date(value).toLocaleDateString('en-ZA', { day: '2-digit', month: 'short', year: 'numeric' });

export const AuditDateDetails = ({ heading, createdDateUTC, createdByName, lastModifiedDateUTC, lastModifiedByName }: IProps) => (
    <>
        <Divider sx={{ mt: 2 }} />
        <MDTypography variant='h6' sx={{ mt: 1, mb: 2 }}>
            {heading}
        </MDTypography>
        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, mt: 2 }}>
            <MDBox>
                <FormLabel sx={labelSx}>Date Created</FormLabel>
                <MDTypography variant='body2'>{formatDate(createdDateUTC)}</MDTypography>
            </MDBox>
            <MDBox>
                <FormLabel sx={labelSx}>Created by</FormLabel>
                <MDTypography variant='body2'>{createdByName}</MDTypography>
            </MDBox>
            {lastModifiedDateUTC && (
                <>
                    <MDBox>
                        <FormLabel sx={labelSx}>Last Date Modified</FormLabel>
                        <MDTypography variant='body2'>{formatDate(lastModifiedDateUTC)}</MDTypography>
                    </MDBox>
                    <MDBox>
                        <FormLabel sx={labelSx}>Modified by</FormLabel>
                        <MDTypography variant='body2'>{lastModifiedByName}</MDTypography>
                    </MDBox>
                </>
            )}
        </Box>
    </>
);
